<template>
  <layout>

    <div className="content">
      <b-card v-if="($account && $account.partner) || ($account && $account.company)" v-html="$t('partners.expert_link_text')">
      </b-card>
    </div>
  </layout>
</template>

<script>

export default {
  name: 'Test3',

  components: {},

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>
